var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
                user_id: null,
                status: null,
                pec: null,
                labeled_at: null,
                marunage_user_id: null,
                issued_at: null,
                sequence_number: null,
            },"filters-default":{
                status: '',
                sort: 'issued_at',
            },"filter-items":[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' } ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 日時が古い順', value: 'issued_at', },
                        { text: '▼ 日時が新しい順', value: '-issued_at' } ],
                } ],"filters-q-placeholder":"名前,SKU","form-modal-id":"marunage","search-action":"marunage/index","filter-search-results":_vm.filterSearchResults,"row-class":"flex-nowrap mx-0 my--2","hide-download":false,"hide-table":true,"open-detail-after-saving":false,"item-id":"id"},on:{"after-save":_vm.afterSave,"after-destroy":_vm.afterDestroy},scopedSlots:_vm._u([{key:"form",fn:function(ref){
            var form = ref.form;
            var init = ref.init;
return [_c('Marunage',{ref:"model",attrs:{"model":form,"init":init,"response":_vm.$refs.gridPage.grid.response},on:{"save":_vm.$refs.gridPage.save,"destroy":_vm.$refs.gridPage.destroy}})]}},{key:"before-filter",fn:function(){return undefined},proxy:true},{key:"after-table",fn:function(){return [_c('MarunageTable',{ref:"table",attrs:{"mode":"read"},on:{"on-detail":_vm.onDetail}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }